// removed by extract-text-webpack-plugin
module.exports = {"nf-loading":"nf-loading","nf-loading__img":"nf-loading__img"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Loading/Loading.scss
// module id = 2740
// module chunks = 1